<template>
	<div class="my-2">
		<div class="bg-white p-3 w-80 m-auto">
			<div class="bg-light d-flex justify-content-center">
				<div class="position-relative" style="min-width: 7em">
					<h5 class="center-vert mx-2">Timeframe:</h5>
				</div>
				<b-form inline>
					<b-form-group class="text-left mx-2">
						<b-form-datepicker
							v-model="form.date"
							size="sm"
							required/>
					</b-form-group>
					<b-form-group class="text-left mx-2">
						<b-form-datepicker
							v-model="form.date"
							size="sm"
							required/>
					</b-form-group>
					<b-button type="submit" variant="primary" class="mx-2 my-2">Generate Report</b-button>
				</b-form>
			</div>
		</div>
		<div class="mx-auto d-flex justify-content-center" style="height: 15em; width: 50em">
			<div class="w-30 m-3 p-2 bg-white position-relative shadow">
				<h5>Total Texts Sent:</h5>
				<h2 class="center text-primary">120</h2>
			</div>
			<div class="w-30 m-3 p-2 bg-white position-relative shadow">
				<h5>Total Texts Recieved:</h5>
				<h2 class="center text-primary">74</h2>
			</div>
			<div class="w-30 m-3 p-2 bg-white position-relative shadow">
				<h5>Total Candidates:</h5>
				<h2 class="center text-primary">45</h2>
			</div>
		</div>
		<div class="mx-auto d-flex justify-content-center" style="width: 50em">
			<b-button variant="primary" class="w-30">Export Candidates in Date Range to Excel</b-button>
		</div>
		<div class="p-2" style="display: none">
			<h3><b>Candidate Pipeline</b></h3>
			<div class="d-flex justify-content-center" style="height: 8em">
				<div class="w-20 m-3 p-2 bg-white position-relative shadow">
					<h5>Recently Applied:</h5>
					<h2 class="center text-primary">120</h2>
				</div>
				<div class="position-relative text-blue" style="width: 3%">
					<v-icon name="arrow-right" scale="2.5" class="center" />
				</div>
				<div class="w-20 m-3 p-2 bg-white position-relative shadow">
					<h5>Screened:</h5>
					<h2 class="center text-primary">74</h2>
				</div>
				<div class="position-relative text-blue" style="width: 3%">
					<v-icon name="arrow-right" scale="2.5" class="center" />
				</div>
				<div class="w-20 m-3 p-2 bg-white position-relative shadow">
					<h5>Interviewed:</h5>
					<h2 class="center text-primary">45</h2>
				</div>
				<div class="position-relative text-blue" style="width: 3%">
					<v-icon name="arrow-right" scale="2.5" class="center" />
				</div>
				<div class="w-20 m-3 p-2 bg-white position-relative shadow">
					<h5>Hired:</h5>
					<h2 class="center text-primary">45</h2>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Reporting",
		data() {
			return {
				form: {
					startDate: null,
					endDate: null
				}
			}
		}
	}
</script>

<style scoped>
</style>